import { useEffect, useState } from "react";
import { cmsCall } from "@/lib/cms";

let cache = null;

/** PDP-templates uit het CMS (standaard + per categorie), één keer per sessie. */
export function usePdpTemplates() {
  const [templates, setTemplates] = useState(cache);

  useEffect(() => {
    if (cache) return;
    cmsCall("GET", "/content/pdp-templates")
      .then((data) => {
        cache = data;
        setTemplates(data);
      })
      .catch(() => setTemplates(null));
  }, []);

  return templates;
}

export function clearPdpTemplateCache() {
  cache = null;
}
